import Image from 'components/shared/image';
import SiteLink from 'components/shared/sitelink';
import RichText from 'components/shared/richtext';
import { addLocaleToHref } from 'lib/utils/helpers';
import { useRouter } from 'next/router';
import styles from './collaborator.module.scss';

const Collaborator = ({ data, locale }) => {
  const { title, collaborator, backgroundColor, anchorId } = data;
  const router = useRouter();

  return (
    <section
      id={anchorId}
      className={styles.collaboratorDettail}
      style={{ backgroundColor: backgroundColor?.color || null }}
    >
      <h2 className={styles.collaboratorDettailTitle}>{title}</h2>
      <div className={styles.collaboratorAvatar}>
        <Image src={collaborator?.avatar} layout="responsive" loading="lazy" />
      </div>
      <div className={styles.collaboratorInfo}>
        <SiteLink
          className={styles.collaboratorTitle}
          locale={locale}
          href={addLocaleToHref(collaborator.slug, locale, router)}
        >
          {collaborator?.title}
        </SiteLink>
        <p className={styles.collaboratorSubtitle}>{collaborator?.subtitle}</p>
      </div>
      <div className={styles.collaboratorDescription}>
        <RichText className={styles.collaboratorDescription} text={collaborator.description.json} />
        <div className={styles.socialLinks}>
          {collaborator?.socialsCollection?.items?.map(social => (
            <SiteLink className={styles.socialIcon} external={`${social?.link}`}>
              <Image src={social?.socialIcon} layout="responsive" loading="lazy" />
            </SiteLink>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Collaborator;
